export default __webpack_public_path__ + "../staticImages/fallback-anbaugebiet.png";